import styled, { css } from "styled-components";

import { foundationColors } from "@/v1/themes/colors";

export const Label = styled.p<{ inverted?: boolean }>`
  font-size: 12px;
  color: ${({ inverted }) =>
    inverted
      ? foundationColors["deep-purple-200"]
      : foundationColors["deep-purple-400"]};
  margin: 0;
`;

export const Value = styled.p<{ emphasized?: boolean }>`
  font-size: ${({ emphasized }) => (emphasized ? "16px" : "14px")};
  font-weight: ${({ emphasized }) => (emphasized ? 500 : 400)};
  margin: 0;
`;

export const SubValue = styled.p`
  font-size: 12px;
  color: ${foundationColors["deep-purple-400"]};
  margin: 0;
`;

export const Td = styled.td`
  transition: background-color 0.2s ease-in-out;
`;

export const Tr = styled.tr<{ isHeaderRow?: boolean; hasBorder?: boolean }>`
  border-bottom: ${({ hasBorder }) =>
    hasBorder ? "2px solid rgb(240, 240, 240)" : "none"};
  ${({ isHeaderRow }) =>
    isHeaderRow
      ? css`
          ${Td} {
            padding: 16px 24px;
          }
        `
      : css`
          ${Td} {
            padding: 12px 24px;
          }
          &:hover > ${Td} {
            background-color: rgb(245, 245, 245);
          }
        `}
`;

export const Tbody = styled.tbody`
  background-color: ${foundationColors["white"]};
  border: 2px solid rgb(240, 240, 240);
`;

export const Spacer = styled.tbody`
  height: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 2px;
`;
